import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { Order } from '../types/order.type';
import { AdminUpdateOrderRequestDTO } from '../types/dtos/admin-update-order.dto';
import { ADMIN_ORDER_API_PATHS } from '../constants/orders-api-paths.constant';

type UseAdminUpdateOrderResult = {
  isUpdating: boolean;
  updateOrder: (orderId: string, payload: AdminUpdateOrderRequestDTO) => Promise<Order | null>;
};

export function useAdminUpdateOrder(): UseAdminUpdateOrderResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isUpdating, setIsUpdating] = useState(false);

  const updateOrder = async (
    orderId: string,
    payload: AdminUpdateOrderRequestDTO
  ): Promise<Order | null> => {
    setIsUpdating(true);
    try {
      const updated = await HttpClient.patch<Order>(ADMIN_ORDER_API_PATHS.UPDATE(orderId), payload);
      enqueueSnackbar('Commande mise à jour avec succès', { variant: 'success' });
      return updated;
    } catch (error) {
      enqueueSnackbar(
        extractApiErrorMessage(error, 'Erreur lors de la mise à jour de la commande'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsUpdating(false);
    }
  };

  return { isUpdating, updateOrder };
}
